import { FC, useEffect, useState } from 'react';
import { Grid, MenuItem } from '@mui/material';
import { SMBSelect } from '../../../components';
import { IDropdownResponse } from '../../../models';
import { useQuery } from 'react-query';
import { getMaterialClassChildren } from '../../../fetch';

interface IManageMaterialsFiltersDropdown {
  materialClassId: string | null;
  depth: number;
  setSelectedMaterialClassIdFilter: React.Dispatch<React.SetStateAction<string | null>>;
  hasAppliedFilters?: boolean;
  width?: number;
  required?: boolean;
}

export const ManageMaterialsFiltersDropdown: FC<IManageMaterialsFiltersDropdown> = ({
  materialClassId,
  depth,
  setSelectedMaterialClassIdFilter,
  hasAppliedFilters,
  width,
  required
}) => {
  const { isLoading: isLoadingDropdown, data: materialClassChildren } = useQuery<
    IDropdownResponse[],
    Error
  >(
    ['material-class-children', materialClassId],
    async () => await getMaterialClassChildren(materialClassId)
  );

  const [selectedMaterialClassId, setSelectedMaterialClassId] = useState(null);

  useEffect(() => {
    if (!hasAppliedFilters) {
      setSelectedMaterialClassId(null);
      setSelectedMaterialClassIdFilter(materialClassId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAppliedFilters]);

  return materialClassChildren?.length > 0 ? (
    <>
      <Grid item xs={12} sm={width || 4}>
        <SMBSelect
          required={required ? true : false}
          onChange={e => {
            setSelectedMaterialClassId(e.target.value);
            setSelectedMaterialClassIdFilter(e.target.value);
          }}
          handleClear={() => {
            setSelectedMaterialClassId(null);
            setSelectedMaterialClassIdFilter(materialClassId);
          }}
          variant="outlined"
          name={`selectedMaterialClassId-${depth ?? 0}`}
          label={depth ? `Sub Category` : `Material Class`}
          id={`selectedMaterialClassId-${depth ?? 0}`}
          value={selectedMaterialClassId}
          disabled={isLoadingDropdown}
          InputLabelProps={{ shrink: !!selectedMaterialClassId }}
        >
          {materialClassChildren?.map((MaterialClass: any, index) => {
            return (
              <MenuItem key={`${index + 1}`} value={MaterialClass.value}>
                {MaterialClass.description}
              </MenuItem>
            );
          })}
        </SMBSelect>
      </Grid>

      {selectedMaterialClassId && (
        <ManageMaterialsFiltersDropdown
          materialClassId={selectedMaterialClassId}
          depth={depth + 1}
          setSelectedMaterialClassIdFilter={setSelectedMaterialClassIdFilter}
          width={width || 4}
        />
      )}
    </>
  ) : null;
};
